import { render } from "./BHeader.vue?vue&type=template&id=24748c01&scoped=true"
import script from "./BHeader.vue?vue&type=script&lang=js"
export * from "./BHeader.vue?vue&type=script&lang=js"

import "./BHeader.vue?vue&type=style&index=0&id=24748c01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24748c01"]])

export default __exports__